/* Lifelong home — page behaviour for the phone view (version of 2026-10-15) and the desktop view (2026-10-21),
   both ported from lifelong-homemobile.netlify.app.
   Each section root carries data-ll="<component>"; components are (re)initialised on page load and
   whenever the theme editor reloads a section. Live data comes from Shopify's Ajax APIs:
   /search/suggest.json (search), /cart.js + /cart/change.js + /cart/add.js (cart), products.json (counts). */
(function () {
  'use strict';
  var LL = (window.LL = window.LL || {});
  LL.routes = LL.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest', root: '/' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var C = {};

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // format paise (cents) with the shop's own money format, e.g. "₹ {{amount}}" -> "₹ 12,299"
  function money(cents) {
    var fmt = (LL.moneyFormat || '₹ {{amount}}').replace(/<[^>]*>/g, ''), v = (Number(cents) || 0) / 100;
    var whole = Math.round(v) === v;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('en-IN');
      return v.toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    });
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function toast(t) {
    var e = $('#toast'); if (!e) return;
    e.textContent = t; e.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { e.classList.remove('on'); }, 1800);
  }
  function holdOn(el, set) {
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) { el.addEventListener(e, function () { set(1); }, { passive: true }); });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (e) { el.addEventListener(e, function () { set(0); }, { passive: true }); });
  }
  function json(url, opts) { return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); }

  /* ---------- Razorpay Magic Checkout (Buy Now, same as the live site) ----------
     The store's Razorpay app is set up in the theme's main layout, which this page doesn't use. So the app's own
     setup (its script + settings, #magic-checkout-data-container) is copied once from a normal page of this same
     theme (/cart) and added here; the app then handles clicks on .button-buy-now exactly as on the live site.
     Nothing in the theme or the app changes. Resolves true when the app is ready, false if it can't load. */
  var magicP = null, magicReady = false;
  function magic() {
    if (magicP) return magicP;
    magicP = fetch(LL.routes.cart, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var box = new DOMParser().parseFromString(html, 'text/html').getElementById('magic-checkout-data-container');
      var cfg = box && box.querySelector('#RazorpayMagicCheckoutConfig'), src = box && box.querySelector('script[src]');
      if (!cfg || !src) return false;
      var mine = document.createElement('div'), conf = document.createElement('script');
      mine.id = 'magic-checkout-data-container'; mine.hidden = true;
      conf.type = 'application/json'; conf.id = 'RazorpayMagicCheckoutConfig'; conf.textContent = cfg.textContent;
      mine.appendChild(conf); document.body.appendChild(mine);
      return new Promise(function (ok) {
        var s = document.createElement('script');
        s.src = src.src; s.crossOrigin = 'anonymous';
        s.onerror = function () { ok(false); };
        // the app sets itself up just after its script runs; it's ready once it watches clicks (it marks that as
        // "listener-attached"). Wait for that, max ~6s.
        var heard = function () { return performance.getEntriesByName && performance.getEntriesByName('listener-attached').length > 0; };
        s.onload = function () { var n = 0; (function wait() { if (window.openRzpCheckout && heard()) ok(true); else if (++n > 60) ok(!!window.openRzpCheckout); else setTimeout(wait, 100); })(); };
        mine.appendChild(s);
      });
    }).catch(function () { return false; }).then(function (ok) { magicReady = ok; return ok; });
    return magicP;
  }
  LL.magic = magic;

  /* ---------- live cart (shared by the header drawer and the Buy Now buttons) ---------- */
  LL.cart = {
    get: function () { return json(LL.routes.cart + '.js', { headers: { Accept: 'application/json' } }); },
    badge: function (n) { $$('[data-ll-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-n', n); }); },
    refresh: function () { return LL.cart.get().then(function (c) { LL.cart.badge(c.item_count); return c; }); }
  };

  /* the header's cart count follows cart changes made by other code too (the theme's own add-to-cart / cart drawer when
     the header is used site-wide): after any request to /cart/add, /change, /update or /clear the count is re-read.
     Set up once; the original fetch / XMLHttpRequest behave exactly as before. */
  function watchCart() {
    if (LL._cartWatch) return; LL._cartWatch = true;
    var re = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/, t = 0;
    function later() { clearTimeout(t); t = setTimeout(function () { LL.cart.refresh().catch(function () {}); }, 250); }
    function hit(u) { try { return re.test(new URL(String(u && u.url || u), location.href).pathname); } catch (_) { return false; } }
    if (window.fetch) {
      var f = window.fetch;
      window.fetch = function (u) { var p = f.apply(this, arguments); if (hit(u)) p.then(later, later); return p; };
    }
    var X = window.XMLHttpRequest && XMLHttpRequest.prototype, o = X && X.open;
    if (o) X.open = function (m, u) { if (hit(u)) this.addEventListener('loadend', later); return o.apply(this, arguments); };
  }

  /* ---------- header: live search + live cart drawer (+ optional menu) ---------- */
  C.header = function (root) {
    var sh = $('#sh', root) || $('#sh');
    if (!sh) return;
    var sb = $('#sb', sh), st = $('#st', sh), view = '', timer;
    function open(title, html, v) { menuIcon(false); st.textContent = title; sb.innerHTML = html; view = v || ''; sh.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { sh.hidden = true; view = ''; document.body.style.overflow = ''; menuIcon(false); }
    // the menu icon turns into a cross while the menu is open; the menu panel then opens below the header so the cross stays visible
    function menuIcon(on) {
      root.classList.toggle('menu-open', on);
      $$('[data-a="menu"]', root).forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      if (on) {
        var bar = $$('.hd2, .lld .hd', root).filter(function (h) { return h.offsetWidth; })[0];
        root.style.setProperty('--hh', bar ? Math.max(0, bar.getBoundingClientRect().bottom) + 'px' : '0px');
      }
    }

    function line(p) {
      return '<a class="pr" href="' + esc(p.url) + '"><div class="im">' + (p.image ? '<img src="' + esc(img(p.image, 160)) + '" alt="">' : '') + '</div>' +
        '<div>' + esc(p.title) + '<br><b>' + money(p.price) + '</b>' + (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') + '</div></a>';
    }
    function search() {
      open(root.getAttribute('data-search-title') || 'Search',
        '<form action="' + esc(LL.routes.search) + '" method="get" role="search"><input type="search" name="q" id="qs" placeholder="' + esc(root.getAttribute('data-search-ph') || 'Search products') + '" autocomplete="off" aria-label="Search"><input type="hidden" name="type" value="product"></form><div id="qr"></div>', 'search');
      var i = $('#qs', sb), r = $('#qr', sb);
      function run() {
        var q = i.value.trim();
        if (!q) { r.innerHTML = '<p class="note">Start typing to search all Lifelong products.</p>'; return; }
        fetch(LL.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (d) {
            if (i.value.trim() !== q) return;            // a newer query is on its way
            var ps = ((d.resources || {}).results || {}).products || [];
            r.innerHTML = ps.length ? ps.map(function (p) {
              return line({ url: p.url, title: p.title, image: p.featured_image && p.featured_image.url || p.image, price: Math.round(parseFloat(p.price) * 100), compare: Math.round(parseFloat(p.compare_at_price_max || 0) * 100) });
            }).join('') + '<a class="all" href="' + esc(LL.routes.search) + '?type=product&q=' + encodeURIComponent(q) + '">See all results ›</a>'
              : '<p>No matches. Try another word.</p>';
          }).catch(function () {});
      }
      i.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
      run(); i.focus();
    }
    function cart() {
      if (view !== 'cart') open(root.getAttribute('data-cart-title') || 'Your cart', '<p class="note">Loading…</p>', 'cart');
      LL.cart.get().then(function (c) {
        LL.cart.badge(c.item_count);
        if (view !== 'cart') return;
        if (!c.item_count) { sb.innerHTML = '<p>Your cart is empty.</p><a class="b" href="' + esc(root.getAttribute('data-shop-url') || '/collections/all') + '">Browse products</a>'; return; }
        sb.innerHTML = c.items.map(function (it) {
          return '<div class="pr"><a class="im" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="">' : '') + '</a>' +
            '<div><a href="' + esc(it.url) + '" style="color:inherit;text-decoration:none">' + esc(it.product_title) + '</a>' +
            (it.variant_title ? '<br><small>' + esc(it.variant_title) + '</small>' : '') + '<br><b>' + money(it.final_line_price) + '</b><br>' +
            '<span class="qt"><button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity - 1) + '" aria-label="Less">&minus;</button>' + it.quantity +
            '<button type="button" data-q="' + esc(it.key) + '" data-n="' + (it.quantity + 1) + '" aria-label="More">+</button></span></div>' +
            '<button type="button" class="mini" data-q="' + esc(it.key) + '" data-n="0">Remove</button></div>';
        }).join('') +
          '<p class="tot"><span>Subtotal</span><b>' + money(c.total_price) + '</b></p><p class="note">Taxes and shipping are calculated at checkout.</p>' +
          '<a class="b" href="/checkout">Checkout</a><a class="all" href="' + esc(LL.routes.cart) + '">View cart ›</a>';
      }).catch(function () { location.href = LL.routes.cart; });
    }
    function menu() {
      var t = $('template[data-view="menu"]', root); if (!t) return;
      open(t.getAttribute('data-title') || 'Menu', '', 'menu'); sb.appendChild(t.content.cloneNode(true)); menuIcon(true);
    }
    LL.openCart = function () { view = ''; cart(); };

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-a]'); if (!a) return;
      var w = a.getAttribute('data-a');
      if (w === 'cart' && root.getAttribute('data-cart-mode') === 'page') return;   // plain link to /cart
      e.preventDefault();
      if (w === 'search') search(); else if (w === 'cart') cart(); else if (view === 'menu') close(); else menu();   // the cross closes the menu
    });
    sh.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) return close();
      // menu drop-downs: an item with sub-links shows its list; the "← name" row goes back a level
      var lvl = e.target.closest('[data-sub],[data-back]');
      if (lvl) {
        var to = lvl.getAttribute('data-sub') || lvl.getAttribute('data-back');
        $$('.mlv', sb).forEach(function (l) { l.hidden = l.getAttribute('data-lv') !== to; });
        sb.scrollTop = 0;
        var first = $('.mlv[data-lv="' + to + '"] .lk', sb); if (first) first.focus({ preventScroll: true });
        return;
      }
      // a menu link to a spot on this page (#faq…) closes the panel; the page-wide in-page link handler
      // (near the end of this file) takes desktop visitors to the desktop copy (#faq-d). On another page (the header
      // used site-wide) that spot isn't there, so it goes to the home page's copy instead (/#faq)
      var hl = e.target.closest('a.lk[href^="#"]');
      if (hl) {
        var hid = hl.getAttribute('href').slice(1);
        if (hid && !document.getElementById(hid) && !document.getElementById(hid + '-d')) { e.preventDefault(); location.href = (LL.routes.root || '/') + '#' + hid; }
        return close();
      }
      var q = e.target.closest('[data-q]');
      if (q) {
        sb.classList.add('busy');
        json(LL.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-q'), quantity: +q.getAttribute('data-n') }) })
          .catch(function (err) { toast((err && err.description) || 'Could not update the cart'); })
          .then(function () { sb.classList.remove('busy'); cart(); });
      }
    });
    function key(e) { if (e.key === 'Escape' && !sh.hidden) close(); }
    document.addEventListener('keydown', key);
    LL.cart.refresh().catch(function () {});
    watchCart();
    return function () { document.removeEventListener('keydown', key); close(); };
  };

  /* ---------- hero ring engine (phone + desktop share it, as on Netlify since 26 Oct) ----------
     Each layout only says how the ring looks (render) and how a drag maps onto it (startDrag / dragBy); everything the
     visitor does works the same everywhere:
       autoplay: one card every few seconds (section settings "Auto-turn every" / "Turn speed")
       swipe (a straight-ish drag, mouse or finger): at most ONE card per drag; on release it carries on at the finger's
         speed and eases onto its card (a spring, no jolt)
       circle (the drag path keeps turning): free spin round the whole loop; with coast (phone) it glides on after release
         and slows down like a real wheel, then parks on a card
       tap / click a side card: it comes to the centre the short way round
       mouse wheel over a card photo: every notch turns it one card, gliding (elsewhere the page scrolls)
     Positions are measured along the loop: card i sits at off + base[i]; the centre spot is AF; L = one full loop. */
  // watch(el): live { on, w, h } for an element (on = on screen, w/h = its size), kept up to date by observers, so per-frame
  // loops never read layout (reading layout right after writing styles makes the browser recalc the page every frame)
  function watch(el) {
    var st = { on: true, w: el.offsetWidth, h: el.offsetHeight };
    if (window.ResizeObserver) new ResizeObserver(function () { st.w = el.offsetWidth; st.h = el.offsetHeight; }).observe(el);
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { var e = es[es.length - 1]; st.on = e.isIntersecting && el.offsetWidth > 0; }, { rootMargin: '150px 0px' }).observe(el);
    return st;
  }

  function heroRing(o) {
    var orbit = o.orbit, cards = o.cards, L = o.L, GAP = o.GAP, AF = o.AF, base = o.base,
      SPIN_TURN = o.spinTurn || Math.PI / 2, SEG = 8,                  // how much the path must turn to count as a circle · px per direction sample
      SPRING = o.spring || 11, COAST = .45,                           // how briskly a swipe settles on its card · seconds a released spin keeps gliding
      WHEEL_STEP = 160, WHEEL_AHEAD = 2, WHEEL_GLIDE = .16;           // trackpad px per card · max cards queued ahead · glide time (s)
    var off = o.off == null ? AF : o.off, raw = 0, tween = null, readyAt = 0, from = 0, dn = false, moved = false, sx = 0, sy = 0, hist = [],
      idleUntil = 0, spin = false, turn = 0, hx = 0, hy = 0, hd = null, wheelAcc = 0, wheelLast = 0, alive = true, raf, hidden = true,
      drawn = '', dirty = true;                                       // last drawn state: nothing moved -> draw nothing (keeps page scrolling smooth)
    function headed() { return tween && tween.to !== undefined && tween.k != 'inout' ? tween.to : snap(off); }   // where a landing move is going
    function wrapD(d) { return ((d % L) + L * 1.5) % L - L / 2; }     // signed shortest distance along the loop
    function snap(v) { return AF + Math.round((v - AF) / GAP) * GAP; } // nearest offset with a card in the centre
    function ease(k, p) {
      if (k == 'land') return 1 - Math.pow(1 - p, 3);
      if (k == 'auto') return .5 - .5 * Math.cos(Math.PI * p);       // auto-turn: gentle sine in-out, no slow crawl at the ends
      return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    }
    // idle: after a visitor's move the auto-turn waits 4.2s; after an auto-turn it doesn't (it used to, which made it turn only every ~10s)
    function go(to, ms, k, idle) { var now = performance.now(); ms = reduce ? 0 : ms; tween = { from: off, to: to, t0: now, ms: ms, k: k || 'inout' }; readyAt = now + ms; idleUntil = now + ms + (idle == null ? 4200 : idle); }
    function chase(to) { tween = { k: 'chase', to: to }; readyAt = Infinity; idleUntil = performance.now() + 4200; }   // smooth follow, retargets without a jolt
    function focusIndex() { for (var i = 0; i < cards.length; i++) if (Math.abs(wrapD(off + base[i] - AF)) < GAP * .006) return i; return -1; }
    function bring(i) { var d = wrapD(AF - (off + base[i])); go(off + d, Math.min(1600, 450 + Math.abs(d) / GAP * 160), 'land'); }
    // auto-turn: one card every o.autoMs (section setting, default 4.5s), each turn o.stepMs long (default 1.8s)
    var AUTO_MS = o.autoMs || 4500, STEP_MS = Math.min(o.stepMs || 1800, AUTO_MS - 300);
    var iv = setInterval(function () { if (!reduce && !design && !dn && !tween && performance.now() > idleUntil && orbit.offsetWidth) go(snap(off) + GAP, STEP_MS, 'auto', 0); }, AUTO_MS);
    // drag (mouse, pen or finger)
    orbit.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      from = headed();                                                 // grabbed while still landing: carry on from where it was going
      dn = true; moved = false; tween = null; raw = off; spin = false; turn = 0; hd = null; hx = sx = e.clientX; hy = sy = e.clientY; hist = []; o.startDrag(e);
    });
    orbit.addEventListener('pointermove', function (e) {
      if (!dn) return;
      if (!moved) {
        if (Math.hypot(e.clientX - sx, e.clientY - sy) < 6) return;
        if (e.pointerType == 'touch' && Math.abs(e.clientY - sy) > Math.abs(e.clientX - sx) * 1.1) { dn = false; return; }   // mostly up/down: scrolling the page
        moved = true; orbit.classList.add('dragging'); try { orbit.setPointerCapture(e.pointerId); } catch (_) {}
      }
      // gesture shape: add up how much the path turns (signed, so jitter cancels out)
      var ddx = e.clientX - hx, ddy = e.clientY - hy;
      if (Math.hypot(ddx, ddy) >= SEG) {
        var h = Math.atan2(ddy, ddx);
        if (hd !== null) { var dh = h - hd; dh -= Math.round(dh / (2 * Math.PI)) * 2 * Math.PI; turn += dh; }
        hd = h; hx = e.clientX; hy = e.clientY; if (!spin && Math.abs(turn) > SPIN_TURN) spin = true;
      }
      var dd = o.dragBy(e);                                            // how far along the loop this move goes
      if (spin) off += o.spinK * dd;                                   // circle: follows the pointer round the whole loop
      else {                                                           // swipe: soft limit at one card, no hard stop
        raw += o.swipeK * dd; var x = (raw - from) / GAP;
        // snappy (phone): follows the finger 1:1 for most of the card and only then softens
        off = from + GAP * (o.snappy ? Math.sign(x) * Math.min(Math.abs(x), .75 + .25 * Math.tanh((Math.abs(x) - .75) / .25)) : Math.tanh(x));
      }
      hist.push([performance.now(), off]); if (hist.length > 8) hist.shift();
    });
    function up(e) {
      if (!dn) return;
      if (e && e.type == 'lostpointercapture' && e.target !== orbit) return;   // touch: a card hands its capture to the ring, the drag goes on
      dn = false; orbit.classList.remove('dragging'); if (!moved) return;
      var a = hist[0], z = hist[hist.length - 1], v = 0;
      if (hist.length > 1 && z[0] > a[0] && performance.now() - z[0] < 100) v = (z[1] - a[1]) / (z[0] - a[0]);
      if (!spin) {                                                     // swipe: at most ONE card, carrying on at the finger's speed (spring)
        var head = off - from + clamp(v * 250, -GAP, GAP),             // where the swipe is heading
          to = o.snappy ? (Math.abs(head) > .2 * GAP ? from + Math.sign(head) * GAP : from)   // snappy: a fifth of a card (or a flick) changes it
            : clamp(snap(off + clamp(v * 250, -GAP, GAP)), from - GAP, from + GAP);
        tween = { k: 'spring', to: to, v: clamp(v * 1000, -6 * GAP, 6 * GAP) }; readyAt = Infinity; idleUntil = performance.now() + 4200; return;
      }
      if (o.coast) { tween = { k: 'coast', v: clamp(v * 1000, -25 * GAP, 25 * GAP) }; readyAt = Infinity; idleUntil = performance.now() + 4200; return; }   // spins on, slowing down
      var end = snap(off + clamp(v * 260, -4 * GAP, 4 * GAP));         // circle: momentum, then it glides to the nearest card
      go(end, Math.min(2000, 600 + 450 * Math.min(4, Math.abs(end - off) / GAP)), 'land');
    }
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { orbit.addEventListener(ev, up); });
    // mouse wheel over a card photo: every notch turns the ring one card (the page stays put); quick notches blend into one
    // smooth spin, at most 2 cards ahead. A trackpad's small steps add up to one notch. Elsewhere the page scrolls as normal.
    orbit.addEventListener('wheel', function (e) {
      if (!e.target.closest(o.card)) return;
      var d = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX; if (!d) return;
      if (e.deltaMode == 1) d *= 40; else if (e.deltaMode == 2) d *= innerHeight;   // lines / pages -> pixels
      e.preventDefault();
      if (dn) return;
      var now = performance.now(); if (now - wheelLast > 300 || Math.sign(d) != Math.sign(wheelAcc)) wheelAcc = 0; wheelLast = now;
      wheelAcc += Math.abs(d) >= 40 ? Math.sign(d) * WHEEL_STEP : d;  // a mouse notch is one whole step; trackpad pixels add up
      var steps = Math.trunc(wheelAcc / WHEEL_STEP); if (!steps) return; wheelAcc -= steps * WHEEL_STEP;
      var start = headed(), here = snap(off);
      chase(clamp(start + steps * GAP, here - WHEEL_AHEAD * GAP, here + WHEEL_AHEAD * GAP));
    }, { passive: false });
    // clicks / taps: a side card comes to the centre; the centre card opens its link once it has stopped there (phone:
    // o.open; desktop: o.centreOpens lets the card's own link work, as on Netlify 3 Nov), and on desktop a card's name
    // (shown on hover) is always its link
    orbit.addEventListener('click', function (e) {
      var el = e.target.closest(o.card);
      if (moved) { moved = false; e.preventDefault(); e.stopPropagation(); return; }   // a drag, not a tap
      if (!el) return;
      if (o.nameLink && e.target.closest('span')) { if (design) e.preventDefault(); return; }   // name: follow the link
      var i = cards.indexOf(el);
      if (o.centreOpens && i == focusIndex() && !tween && performance.now() >= readyAt) { if (design) e.preventDefault(); return; }   // settled centre card: its link
      if (i == focusIndex() && o.open && !tween && performance.now() >= readyAt) { e.preventDefault(); o.open(el); return; }   // settled centre card
      e.preventDefault();
      if (tween || i == focusIndex()) return;                         // already in the centre
      bring(i);
    });
    orbit.addEventListener('keydown', function (e) {
      var el = e.target.closest(o.card); if (!el) return;
      if (e.key == ' ' || (e.key == 'Enter' && o.open)) { e.preventDefault(); var i = cards.indexOf(el); if (i == focusIndex() && o.open) o.open(el); else if (!tween) bring(i); }
      else if (e.key == 'ArrowRight' || e.key == 'ArrowLeft') { e.preventDefault(); go(snap(tween ? tween.to : off) + (e.key == 'ArrowRight' ? GAP : -GAP), 500); }
    });
    cards.forEach(function (c) { c.draggable = false; c.addEventListener('dragstart', function (e) { e.preventDefault(); }); });
    // one frame loop: move along the current tween, then let the layout draw the ring
    var last = performance.now(), vis = watch(orbit);
    function tick(now) {
      if (!alive) return;
      raf = requestAnimationFrame(tick);
      var dt = Math.min(.05, (now - last) / 1000); last = now;
      if (!vis.w) { hidden = true; return; }                           // this layout is hidden
      if (!vis.on && !tween) return;                                   // off screen and still: nothing to do
      if (hidden) { hidden = false; dirty = true; if (o.shown) o.shown(); }   // just became visible: let the layout measure itself
      if (tween && tween.k == 'coast') {                               // free spin after release: the speed fades; once slow, a spring parks it ahead
        tween.v *= Math.exp(-dt / COAST); off += tween.v * dt;
        if (reduce || Math.abs(tween.v) < 2.5 * GAP) tween = { k: 'spring', to: snap(off + tween.v * .12), v: tween.v };
      } else if (tween && tween.k == 'spring') {                       // critically damped spring: no overshoot, keeps the release speed
        if (reduce) { off = tween.to; tween.v = 0; } else { tween.v += (-SPRING * SPRING * (off - tween.to) - 2 * SPRING * tween.v) * dt; off += tween.v * dt; }
        if (Math.abs(tween.to - off) < GAP * .002 && Math.abs(tween.v) < GAP * .05) { off = tween.to; tween = null; readyAt = now; idleUntil = now + 4200; }
      } else if (tween && tween.k == 'chase') {
        off += (tween.to - off) * (reduce ? 1 : 1 - Math.exp(-dt / WHEEL_GLIDE));
        if (Math.abs(tween.to - off) < GAP * .002) { off = tween.to; tween = null; readyAt = now; idleUntil = now + 4200; }
      } else if (tween) { var p = tween.ms ? Math.min(1, (now - tween.t0) / tween.ms) : 1; off = tween.from + (tween.to - tween.from) * ease(tween.k, p); if (p >= 1) tween = null; }
      var key = off.toFixed(4) + '|' + vis.w + 'x' + vis.h;
      if (key !== drawn || dirty) { drawn = key; dirty = false; o.render(off, wrapD, vis); }
    }
    function redraw() { dirty = true; }
    addEventListener('resize', redraw); addEventListener('load', redraw); if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
    var late = setTimeout(redraw, 1200);
    raf = requestAnimationFrame(tick);
    return function () { alive = false; cancelAnimationFrame(raf); clearInterval(iv); clearTimeout(late); removeEventListener('resize', redraw); removeEventListener('load', redraw); };
  }

  /* ---------- hero (phone): 17 fixed spots around the hero; spot 11 is the big centre card at the bottom. A card between two
     spots is drawn part-way between them, so the ring moves smoothly. Tap a side card to bring it to the centre, drag to
     spin, tap the centre card to open its link. ---------- */
  C.hero = function (root) {
    var col = $('.col', root); if (!col) return;
    var R = [[-3.23, 10.569], [12.935, 3.577], [29.602, 0], [51.741, 1.463], [69.652, 6.341], [83.831, 15.285], [93.284, 26.667], [97.015, 39.187], [93.284, 51.707], [83.831, 63.577], [70.896, 71.707], [0.995, 67.967], [-15.42, 57.886], [-21.64, 45.691], [-15.67, 32.52], [-26, 21.5]],
      CT = [22.388, 60.976, 54.726, 39.024], W = 24.876, H = 22.764, L = R.length + 1, MID = 11, PX = 170,
      cs = $$('.cd', col), n = cs.length;
    if (!n) return;
    function mod(k) { return ((k % L) + L) % L; }
    function rc(p) { if (p == MID) return CT; var r = R[p < MID ? p : p - 1]; return [r[0], r[1], W, H]; }
    function rad(p) { return p == MID ? 5.2 : 3.2; }
    col.style.setProperty('--d', '0s');                               // the engine moves the cards every frame: no CSS transition on their size/position
    cs.forEach(function (e) { e.style.left = '0'; e.style.top = '0'; });   // position comes from translate (GPU, no layout)
    var lx = 0, ly = 0, cx = 0, cy = 0, base = cs.map(function (_, i) { return i == n - 1 ? MID : (i < MID ? i : i + 1); });   // the last card starts in the centre
    return heroRing({
      orbit: col, cards: cs, card: '.cd', L: L, GAP: 1, AF: MID, off: 0, spinK: 1.9, swipeK: 1.6, spinTurn: Math.PI / 3, coast: true, snappy: true, spring: 17,
      autoMs: parseFloat(root.getAttribute('data-auto-ms')) || 0, stepMs: parseFloat(root.getAttribute('data-step-ms')) || 0,
      base: base,
      open: function (el) { var h = el.getAttribute('data-href'); if (h && !design) window.open(h, root.getAttribute('data-target') || '_blank', 'noopener'); },
      startDrag: function (e) {
        lx = e.clientX; ly = e.clientY;
        var b = col.getBoundingClientRect(); cx = b.left + b.width / 2; cy = b.top + b.height * 0.45;   // ring centre, measured once per drag
      },
      // how far along the ring a move goes: the part of it that runs round the ring's centre
      dragBy: function (e) {
        var dx = e.clientX - lx, dy = e.clientY - ly; lx = e.clientX; ly = e.clientY;
        var rx = e.clientX - cx, ry = e.clientY - cy, r = Math.hypot(rx, ry);
        return r > 50 ? (dx * -ry + dy * rx) / r / PX : 0;
      },
      // position = translate (GPU, no layout); size, radius, centre class and z-index are written only when they change,
      // so a gliding ring (or the page scrolling past it) costs almost nothing per frame
      render: function (off, wrapD, vis) {
        var Wd = vis.w, Hd = vis.h;                                    // the ring's size, from the observer (no layout read)
        cs.forEach(function (e, i) {
          var q = off + base[i], fl = Math.floor(q), f = q - fl, a = mod(fl), b = mod(fl + 1), A = rc(a), B = rc(b), st = e.style, m = e._m || (e._m = {});
          function v(j) { return A[j] + (B[j] - A[j]) * f; }
          function set(k, val, fn) { if (m[k] !== val) { m[k] = val; fn(val); } }
          set('xy', (v(0) * Wd / 100).toFixed(1) + 'px ' + (v(1) * Hd / 100).toFixed(1) + 'px', function (x) { st.translate = x; });
          set('w', v(2).toFixed(2) + '%', function (x) { st.width = x; }); set('h', v(3).toFixed(2) + '%', function (x) { st.height = x; });
          set('r', (rad(a) + (rad(b) - rad(a)) * f).toFixed(2) + 'cqw', function (x) { st.borderRadius = x; });
          var g = Math.max(0, 1 - Math.abs(wrapD(q - MID))), w = g * g * (3 - 2 * g);   // w: 1 at the centre spot
          set('c', mod(Math.round(q)) == MID, function (x) { e.classList.toggle('ctr', x); });
          set('l', Math.pow(w, 4).toFixed(3), function (x) { st.setProperty('--label', x); });
          set('z', w > .5 ? '3' : w > 0 ? '2' : '1', function (x) { st.zIndex = x; });
        });
      }
    });
  };

  /* ---------- feature stack (phone), as on Netlify (2 Nov): wide photo cards side by side on the red block; the cards run
       once, in order (no looping). pos = which card shows (fractional while moving).
       swipe / drag sideways: the cards follow the finger and settle on the next / previous card (a quick flick moves on
         one card); up / down scrolls the page as normal
       auto-slide: once the whole section is on screen, one card every 3.2s, stopping on the last card ---------- */
  C['feature-stack'] = function (fs) {
    var stage = $('.fs-stage', fs), cards = $$('.sd', fs), n = cards.length,
      SLIDE = 600, AUTO = 3200, FIRST = 1200, GAP = 2.7 / 87;
      // slide time (ms) · auto-slide interval (ms) · wait after it comes into view (ms) · gap between cards (share of card width)
    if (!stage || !n) return;
    var target = 0, pos = 0, from = 0, t0 = 0, run = 0, step = 300, userAt = 0, changedAt = 0, activeAt = 0, alive = true,
      dragging = false, moved = false, id = null, sx = 0, sp = 0, lx = 0, lt = 0, vx = 0;
    function inView() {
      var r = fs.getBoundingClientRect(), hd = $('.ll .hd2'), h = hd && hd.offsetHeight ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
      return fs.offsetWidth > 0 && r.top >= h - 2 && r.bottom <= innerHeight + 2;
    }
    function draw() {
      cards.forEach(function (c, i) { var d = i - pos; c.style.transform = 'translate3d(' + (d * step).toFixed(1) + 'px,0,0)'; c.style.visibility = Math.abs(d) > 1.6 ? 'hidden' : ''; });
    }
    function tick(now) {
      if (!alive) return;
      var p = reduce ? 1 : Math.min(1, (now - t0) / SLIDE);           // ease-out
      pos = from + (target - from) * (1 - Math.pow(1 - p, 3)); if (p >= 1) pos = target;
      draw(); run = pos !== target ? requestAnimationFrame(tick) : 0;
    }
    function goTo(i) { target = clamp(i, 0, n - 1); from = pos; t0 = changedAt = performance.now(); if (!run) run = requestAnimationFrame(tick); }
    // finger / mouse: drag sideways, let go -> the nearest card (or the next one after a quick flick)
    fs.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button) return;
      id = e.pointerId; sx = lx = e.clientX; lt = e.timeStamp; vx = 0; sp = pos; moved = false; dragging = true; userAt = performance.now();
      cancelAnimationFrame(run); run = 0;
    });
    fs.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== id) return;
      var dx = e.clientX - sx;
      if (!moved) { if (Math.abs(dx) < 6) return; moved = true; try { fs.setPointerCapture(id); } catch (_) {} }
      var dt = Math.max(1, e.timeStamp - lt); vx = vx * .6 + (e.clientX - lx) / dt * .4; lx = e.clientX; lt = e.timeStamp;
      pos = clamp(sp - dx / step, -.2, n - .8); draw(); userAt = performance.now();
    });
    function release(e) {
      if (!dragging || e.pointerId !== id) return;
      dragging = false; userAt = performance.now();
      if (!moved) { if (pos !== target) goTo(Math.round(pos)); return; }   // a tap: finish any slide it interrupted
      var base = Math.round(sp), flick = e.type === 'pointerup' && Math.abs(vx) > .35;
      goTo(flick ? base + (vx < 0 ? 1 : -1) : pos > base + .18 ? base + 1 : pos < base - .18 ? base - 1 : base);
    }
    fs.addEventListener('pointerup', release); fs.addEventListener('pointercancel', release);
    fs.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);   // a swipe is not a tap on the link
    fs.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // theme editor: selecting a slide brings it in
    function sel(e) { var j = cards.indexOf(e.target); if (j > -1) goTo(j); }
    document.addEventListener('shopify:block:select', sel);
    // auto-slide: starts once the section is fully on screen, one card at a time, stops on the last card
    var iv = reduce || design || fs.getAttribute('data-auto') === 'false' ? 0 : setInterval(function () {
      var now = performance.now();
      if (document.hidden || dragging || !inView()) { activeAt = 0; return; }
      if (!activeAt) { activeAt = now; return; }
      if (run || target >= n - 1 || now - activeAt < FIRST || now - userAt < AUTO || now - changedAt < AUTO) return;
      goTo(target + 1);
    }, 250);
    function measure() { step = cards[0].offsetWidth * (1 + GAP); draw(); }
    addEventListener('resize', measure); addEventListener('load', measure);
    var ro = window.ResizeObserver ? new ResizeObserver(measure) : null; if (ro) ro.observe(stage);
    measure();
    return function () {
      alive = false; cancelAnimationFrame(run); clearInterval(iv);
      document.removeEventListener('shopify:block:select', sel); removeEventListener('resize', measure); removeEventListener('load', measure); if (ro) ro.disconnect();
    };
  };

  /* ---------- product tabs: tab switching, auto-scroll, add to cart ---------- */
  C['product-tabs'] = function (sec) {
    var tabs = $('.tabs', sec), btns = $$('[data-tab]', tabs), panes = $$('[data-pane]', sec), cur = 0, hold = 0, iv = null;
    function show(k) {
      cur = k;
      btns.forEach(function (b, j) { b.classList.toggle('on', j == k); b.setAttribute('aria-selected', j == k ? 'true' : 'false'); });
      panes.forEach(function (p, j) { p.hidden = j != k; if (j == k) p.scrollLeft = 0; });
    }
    btns.forEach(function (b, j) {
      b.addEventListener('click', function () {
        show(j);
        setTimeout(function () { var tr = tabs.getBoundingClientRect(), br = b.getBoundingClientRect(); tabs.scrollTo({ left: tabs.scrollLeft + br.left - tr.left - (tr.width - br.width) / 2, behavior: 'smooth' }); }, 280);
      });
    });
    holdOn(sec, function (v) { hold = v; });
    // desktop rows (.row) can be dragged sideways with the mouse: the row follows the mouse 1:1; on release it keeps the
    // drag's speed and glides (eases out, 650ms) to the nearest card, so there's no instant snap jump; a quick flick goes
    // a card or two further (Netlify 3 Nov). Snapping is off while dragging / gliding.
    panes.forEach(function (r) {
      if (!r.classList.contains('row')) return;
      var d = false, mv = false, sx = 0, sl = 0, id = 0, lx = 0, lt = 0, v = 0, anim = 0, GLIDE = 650, FLICK = 300;
      function pitch() { var c = r.children; return c[1] ? c[1].offsetLeft - c[0].offsetLeft : r.clientWidth; }
      function snapOff(on) { r.style.scrollSnapType = on ? 'none' : ''; r.style.scrollBehavior = on ? 'auto' : ''; }
      function stop() { cancelAnimationFrame(anim); anim = 0; snapOff(false); }
      function glide(to) {
        var from = r.scrollLeft, t0 = performance.now(), ms = reduce ? 0 : GLIDE;
        cancelAnimationFrame(anim); snapOff(true);
        (function step(now) {
          var p = ms ? Math.min(1, (now - t0) / ms) : 1;
          r.scrollLeft = from + (to - from) * (1 - Math.pow(1 - p, 3));
          if (p < 1) anim = requestAnimationFrame(step); else { anim = 0; snapOff(false); }
        })(t0);
      }
      r.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button) return; stop(); d = true; mv = false; sx = lx = e.clientX; lt = e.timeStamp; v = 0; sl = r.scrollLeft; id = e.pointerId; });
      r.addEventListener('pointermove', function (e) {
        if (!d) return; var dx = e.clientX - sx;
        if (!mv && Math.abs(dx) > 5) { mv = true; r.classList.add('dragging'); try { r.setPointerCapture(id); } catch (_) {} }
        if (!mv) return;
        var dt = Math.max(1, e.timeStamp - lt); v = v * .5 + (e.clientX - lx) / dt * .5; lx = e.clientX; lt = e.timeStamp;   // drag speed (px/ms), smoothed
        r.scrollLeft = sl - dx;
      });
      function end(e) {
        if (!d) return; d = false; if (!mv) return;
        var p = pitch(), fresh = e && e.timeStamp - lt < 80,                 // mouse still moving when let go: keep its speed
          carry = Math.max(-1.5 * p, Math.min(1.5 * p, fresh ? -v * FLICK : 0)),
          to = Math.max(0, Math.min(r.scrollWidth - r.clientWidth, Math.round((r.scrollLeft + carry) / p) * p));
        snapOff(true); r.classList.remove('dragging'); glide(to);
        setTimeout(function () { mv = false; }, 0);
      }
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { r.addEventListener(ev, end); });
      r.addEventListener('wheel', stop, { passive: true });
      r.addEventListener('click', function (e) { if (mv) { e.preventDefault(); e.stopPropagation(); } }, true);
      r.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
    if (sec.getAttribute('data-autoplay') === 'true' && !reduce && !design) {
      iv = setInterval(function () {
        var trk = panes[cur]; if (hold || !trk || !sec.offsetWidth) return;
        var c = trk.firstElementChild, gap = parseFloat(getComputedStyle(trk).columnGap) || 14, stepW = c ? c.offsetWidth + gap : 0,
          end = trk.scrollLeft >= trk.scrollWidth - trk.clientWidth - 4;
        trk.scrollTo({ left: end ? 0 : trk.scrollLeft + stepW, behavior: 'smooth' });
      }, 3500);
    }
    // Buy Now via Razorpay (setting "After Buy Now"): load the store's Razorpay app soon after the page (or at the first
    // touch of a card), so it's ready when Buy Now is pressed. It then takes the click itself, like on the live site.
    var rzp = sec.getAttribute('data-after-add') === 'razorpay' && !design && $('.button-buy-now', sec);
    if (rzp) {
      var early = function () { magic(); };
      setTimeout(early, 2500);
      sec.addEventListener('pointerdown', early, { once: true, passive: true });
    }
    sec.addEventListener('submit', function (e) {
      var f = e.target.closest('form.ll-atc'); if (!f || !window.fetch) return;
      e.preventDefault();
      var b = $('button', f);
      // pressed before Razorpay was ready: wait for it and press again (Razorpay takes that click);
      // if it can't load, carry on below and open the cart panel instead
      if (rzp && !magicReady && !f._rzpTried) {
        f._rzpTried = true; b.disabled = true;
        Promise.race([magic(), new Promise(function (r) { setTimeout(function () { r(false); }, 6000); })])     // never wait more than 6s
          .then(function (ok) { b.disabled = false; if (ok) b.click(); else if (f.requestSubmit) f.requestSubmit(b); else b.click(); });
        return;
      }
      b.disabled = true;
      json(LL.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function () {
          var after = sec.getAttribute('data-after-add');
          if (after === 'razorpay') after = 'drawer';                                   // Razorpay didn't load
          if (after === 'cart') { location.href = LL.routes.cart; return; }
          if (after === 'checkout') { location.href = '/checkout'; return; }
          b.classList.add('ok'); toast('Added to cart');
          if (after === 'drawer' && LL.openCart) LL.openCart(); else LL.cart.refresh();
        })
        .catch(function (err) { toast((err && err.description) || 'Could not add to cart'); })
        .then(function () { b.disabled = false; });
    });
    return function () { clearInterval(iv); };
  };

  /* ---------- generic snap slider with auto-advance (value cards, gifting, reviews) ---------- */
  C.slider = function (el) {
    var k = [].slice.call(el.children), cur = 0, hold = 0, ms = parseFloat(el.getAttribute('data-ms')) || 0, iv = null;
    if (k.length < 2) return;
    function pos(i) { return k[i].offsetLeft - k[0].offsetLeft; }
    var start = parseInt(el.getAttribute('data-start'), 10);
    if (start > 0 && k[start]) { cur = start; el.scrollLeft = k[start].offsetLeft - (el.clientWidth - k[start].offsetWidth) / 2; }
    el.addEventListener('scroll', function () {
      var x = el.scrollLeft, b = 0, m = 1e9;
      k.forEach(function (c, i) { var d = Math.abs(pos(i) - x); if (d < m) { m = d; b = i; } });
      cur = b;
    }, { passive: true });
    holdOn(el, function (v) { hold = v; });
    if (ms > 0 && !reduce && !design) iv = setInterval(function () { if (hold || !el.offsetWidth) return; cur = (cur + 1) % k.length; el.scrollTo({ left: pos(cur), behavior: 'smooth' }); }, ms);
    return function () { clearInterval(iv); };
  };

  /* ---------- categories: exact in-stock counts for collections too big for Liquid to loop (>50 products) ---------- */
  C.categories = function (root) {
    $$('[data-instock]', root).forEach(function (sup) {
      var handle = sup.getAttribute('data-instock'), total = 0, base = (LL.routes.root || '/').replace(/\/?$/, '/');
      (function page(p) {
        fetch(base + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + p)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var list = d.products || [];
            list.forEach(function (x) { if ((x.variants || []).some(function (v) { return v.available; })) total++; });
            if (list.length === 250 && p < 20) page(p + 1); else sup.textContent = total ? '(' + total + ')' : '';
          })
          .catch(function () {});                                         // keep the server-side count
      })(1);
    });
  };

  /* ---------- FAQ: one answer open at a time; arrow reveals the rest ---------- */
  C.faq = function (root) {
    var faq = $('.faq', root);
    root.addEventListener('click', function (e) {
      var a = e.target.closest('.q>button');
      if (a) {
        var q = a.parentNode, o = !q.classList.contains('o');
        $$('.q.o', root).forEach(function (x) { if (x !== q) { x.classList.remove('o'); $('button', x).setAttribute('aria-expanded', 'false'); } });
        q.classList.toggle('o', o); a.setAttribute('aria-expanded', o ? 'true' : 'false');
        return;
      }
      var b = e.target.closest('.more');
      if (b && faq) {
        var open = !faq.classList.contains('o');
        faq.classList.toggle('o', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.setAttribute('aria-label', open ? 'Show fewer questions' : 'Show more questions');
        if (!open) setTimeout(function () { var r = b.getBoundingClientRect(); if (r.top < 0 || r.bottom > innerHeight) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 460);
      }
    });
  };

  /* ---------- icon strip: endless auto-scroll, draggable with momentum, icons are links ---------- */
  /* ---------- icon strips: red "filled" copy of each drawn icon (the centre one, and on desktop the hovered one, shows it) ----------
     Made in the browser from the icon's own picture, as in the design: the outline stays, small gaps in it are closed,
     everything inside turns red and the drawing's inner lines turn white so it stays readable. Each picture is worked out
     once (cached) and the result goes to every copy of that icon. If the picture can't be read, the outline just turns red. */
  var ICO = {
    cache: {}, blocked: false,
    RED: 'brightness(0) saturate(100%) invert(13%) sepia(99%) saturate(7404%) hue-rotate(4deg) brightness(95%) contrast(118%)',
    // square dilation by r pixels (rows, then columns), using running sums so it costs the same for any r
    grow: function (m, w, h, r) {
      var t = new Uint8Array(w * h), o = new Uint8Array(w * h), y, x, s;
      for (y = 0; y < h; y++) {
        var row = y * w; s = 0;
        for (x = 0; x < Math.min(r, w); x++) s += m[row + x];
        for (x = 0; x < w; x++) {
          if (x + r < w) s += m[row + x + r];
          if (x - r - 1 >= 0) s -= m[row + x - r - 1];
          t[row + x] = s > 0 ? 1 : 0;
        }
      }
      for (x = 0; x < w; x++) {
        s = 0;
        for (y = 0; y < Math.min(r, h); y++) s += t[y * w + x];
        for (y = 0; y < h; y++) {
          if (y + r < h) s += t[(y + r) * w + x];
          if (y - r - 1 >= 0) s -= t[(y - r - 1) * w + x];
          o[y * w + x] = s > 0 ? 1 : 0;
        }
      }
      return o;
    },
    make: function (src) {
      if (ICO.cache[src]) return ICO.cache[src];
      return (ICO.cache[src] = new Promise(function (res) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var nw = im.naturalWidth, nh = im.naturalHeight, S = Math.max(1, Math.min(4, Math.ceil(500 / Math.max(nw, nh)))),
              W = nw * S, H = nh * S, P = 8 * S, w = W + 2 * P, h = H + 2 * P, n = w * h, c = document.createElement('canvas');
            c.width = w; c.height = h;
            var x = c.getContext('2d', { willReadFrequently: true }); x.imageSmoothingQuality = 'high'; x.drawImage(im, P, P, W, H);
            var d = x.getImageData(0, 0, w, h), a = d.data, ink = new Uint8Array(n), i;
            for (i = 0; i < n; i++) ink[i] = a[i * 4 + 3] > 60 ? 1 : 0;
            var R = Math.max(2, Math.round(Math.min(W, H) * .025)), wall = ICO.grow(ink, w, h, R), out = new Uint8Array(n), st = [0];
            out[0] = 1;                                                    // flood the outside from a corner, stopping at the (gap-closed) outline
            while (st.length) {
              var p = st.pop(), px = p % w, py = (p / w) | 0;
              if (px > 0 && !out[p - 1] && !wall[p - 1]) { out[p - 1] = 1; st.push(p - 1); }
              if (px < w - 1 && !out[p + 1] && !wall[p + 1]) { out[p + 1] = 1; st.push(p + 1); }
              if (py > 0 && !out[p - w] && !wall[p - w]) { out[p - w] = 1; st.push(p - w); }
              if (py < h - 1 && !out[p + w] && !wall[p + w]) { out[p + w] = 1; st.push(p + w); }
            }
            var outside = ICO.grow(out, w, h, R),                         // give back what closing the gaps took
              L = Math.max(3, Math.round(Math.min(W, H) * .04)), edge = ICO.grow(out, w, h, R + L);   // band of the outer outline
            for (i = 0; i < n; i++) {
              if (outside[i]) continue;                                   // outside the icon: as drawn
              var j = i * 4, tt = edge[i] ? 0 : a[j + 3] / 255;          // inner line strength (0 on the outer outline)
              a[j] = 255; a[j + 1] = a[j + 2] = Math.round(255 * tt); a[j + 3] = 255;   // red, inner lines blend to white
            }
            x.putImageData(d, 0, 0);
            var o = document.createElement('canvas'); o.width = W; o.height = H; o.getContext('2d').drawImage(c, -P, -P);
            res(o.toDataURL());
          } catch (e) { ICO.blocked = true; res(null); }
        };
        im.onerror = function () { res(null); };
        im.src = src;
      }));
    },
    // give every icon link in `root` a filled copy (.llfill) on top of its picture
    wrap: function (root) {
      var todo = [];
      $$('.ia', root).forEach(function (it) {
        if ($('.llfill', it)) return;
        var b = $('img:not(.f):not(.bag-fill):not(.llfill)', it); if (!b) return;
        var src = b.getAttribute('src'); if (!src) return;
        var f = new Image(); f.className = 'llfill'; f.alt = ''; f.setAttribute('aria-hidden', 'true'); f.setAttribute('data-ico', src); f.draggable = false;
        it.appendChild(f);
        if (todo.indexOf(src) < 0) todo.push(src);
      });
      // one picture at a time, after the page has settled, so scrolling stays smooth
      (function next() {
        var src = todo.shift(); if (!src) return;
        setTimeout(function () {
          ICO.make(src).then(function (u) {
            $$('img.llfill').forEach(function (f) {
              if (f.getAttribute('data-ico') !== src || f.getAttribute('src')) return;
              if (u) f.src = u; else if (ICO.blocked) { f.src = src; f.style.filter = ICO.RED; } else { f.remove(); return; }
              f.parentNode.classList.add('has-llfill');
            });
            next();
          });
        }, 120);
      })();
    }
  };

  C['icon-strip'] = function (box) {
    var t = $('.itr', box); if (!t) return;
    ICO.wrap(t);
    var bags = $$('.ia', t), secs = parseFloat(box.getAttribute('data-seconds')) || 30,
      speed = -1, x = 0, v = 0, half = 0, dn = false, px = 0, lt = 0, last = performance.now(), hold = 0, raf, alive = true;
    var vis = watch(box), mids = [], lit = null;
    // icon centres in strip coordinates (before the slide offset), measured on resize / load, not every frame
    function measure() { half = t.scrollWidth / 2; speed = -half / secs; var s0 = box.getBoundingClientRect().left; mids = bags.map(function (b) { var r = b.getBoundingClientRect(); return r.left - s0 - x + r.width / 2; }); }
    function wrap() { if (!half) return; while (x <= -half) x += half; while (x > 0) x -= half; }
    measure(); addEventListener('resize', measure); addEventListener('load', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(t);
    // a press only becomes a drag after 6px of movement, so a plain tap/click still opens the icon's link
    var dragging = false, travel = 0, over = false, justDragged = false;
    box.addEventListener('pointerdown', function (e) { dn = true; dragging = false; travel = 0; px = e.clientX; lt = e.timeStamp; v = 0; box._pid = e.pointerId; });
    box.addEventListener('pointermove', function (e) {
      if (!dn) return;
      var dx = e.clientX - px, dt = Math.max(1, e.timeStamp - lt);
      travel += Math.abs(dx);
      if (!dragging) { if (travel < 6) return; dragging = true; box.classList.add('drag'); try { box.setPointerCapture(box._pid); } catch (_) {} }
      x += dx; v = dx / dt * 1000; px = e.clientX; lt = e.timeStamp; wrap();
    });
    function up() {
      if (!dn) return; dn = false;
      if (dragging) { justDragged = true; setTimeout(function () { justDragged = false; }, 50); }
      dragging = false; box.classList.remove('drag'); hold = performance.now() + 900;
    }
    box.addEventListener('pointerup', up); box.addEventListener('pointercancel', up); box.addEventListener('lostpointercapture', up);
    box.addEventListener('click', function (e) { if (justDragged) { e.preventDefault(); e.stopPropagation(); } }, true);
    // pause while a mouse is over the strip so an icon can be clicked
    box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') over = true; });
    box.addEventListener('pointerleave', function () { over = false; });
    (function tick(now) {
      if (!alive) return;
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (!vis.on || !vis.w) { raf = requestAnimationFrame(tick); return; }   // desktop view showing, or off screen
      if (!dn) {
        if (Math.abs(v) > 5) { x += v * dt; v *= Math.pow(0.04, dt); }  // short glide after letting go
        else { v = 0; if (!reduce && !over && now > hold) x += speed * dt; }
        wrap();
      }
      t.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      var m = vis.w / 2, best = null, bd = 1e9;                        // only the icon nearest the middle fills
      bags.forEach(function (b, i) { var dd = Math.abs(mids[i] + x - m); if (dd < bd) { bd = dd; best = b; } });
      if (bd >= vis.w * .3) best = null;
      if (best !== lit) { if (lit) lit.classList.remove('on'); if (best) best.classList.add('on'); lit = best; }
      raf = requestAnimationFrame(tick);
    })(last);
    return function () { alive = false; cancelAnimationFrame(raf); removeEventListener('resize', measure); };
  };

  /* ---------- footer: link accordions + newsletter sign-up without leaving the page ---------- */
  C.footer = function (ft) {
    $$('.fa>button', ft).forEach(function (bt) {
      bt.addEventListener('click', function () {
        var d = bt.parentNode, o = !d.classList.contains('o');
        $$('.fa.o', ft).forEach(function (x) { if (x !== d) { x.classList.remove('o'); $('button', x).setAttribute('aria-expanded', 'false'); } });
        d.classList.toggle('o', o); bt.setAttribute('aria-expanded', o ? 'true' : 'false');
      });
    });
    var f = $('form', ft); if (!f) return;
    var i = $('input[type=email]', f), m = $('.nm', f), b = $('button', f), ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
      thanks = ft.getAttribute('data-thanks') || 'Thanks! You are subscribed.';
    function say(t, bad) { m.textContent = t; m.classList.toggle('err', !!bad); i.classList.toggle('bad', !!bad); i.setAttribute('aria-invalid', bad ? 'true' : 'false'); }
    i.addEventListener('input', function () { say(''); });
    f.addEventListener('submit', function (e) {
      var val = i.value.trim();
      if (!ok.test(val)) { e.preventDefault(); say(val ? 'Please enter a valid email address.' : 'Please enter your email address.', 1); i.focus(); return; }
      if (!window.fetch) return;
      e.preventDefault(); b.disabled = true;
      fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
        .then(function (r) { if (r.ok && r.url.indexOf('challenge') < 0) { say(thanks); f.reset(); b.disabled = false; } else f.submit(); })
        .catch(function () { f.submit(); });
    });
  };

  /* =====================================================================
     DESKTOP VIEW (.lld, 860px and wider) — ported from the design's desktop layout.
     Each section prints its desktop view next to the phone one; only one is visible, and the hidden one's
     timers skip their work (offsetWidth is 0 while hidden).
     ===================================================================== */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* hero: cards travel round a round ring; the one at the bottom centre grows and shows its title.
     Moves with the shared ring engine (heroRing, same as the phone): one card every 5.2s, a swipe moves one card, a circular
     drag spins it freely, each wheel notch over a photo turns it one card. Hovering a card shows its name;
     clicking the name opens the link, clicking the photo brings the card to the centre. Cards drift up at different speeds as you scroll.
     The ring is drawn for a 1440x900 hero and fitted to the real screen: the hero fills the full width and height, top-row cards
     sit on the header line and bottom-row cards on the hero bottom (at most a quarter of a card hides), cards passing above or
     below the heading are pushed out of its way, and the centre card shrinks on short screens so it never reaches the heading. */
  C['d-hero'] = function (hero) {
    var orbit = $('.orbit', hero), inner = $('.in', hero), els = $$('.orbit-card', orbit), N = els.length;
    if (!N) return;
    var CX = 720, CY = 450, RX = 470, RY = 440, PW = 2,               // loop shape, in 1440x900 design units (PW 2 = round)
      FOCUS = { x: 720, y: 755, w: 340, h: 290 },                     // centre card: middle point and size
      CUT = .25, REACH = -70, TGAP = 10,                              // max share of a card that may hide · ring reach past header/bottom · min gap to the heading
      SIDE = [44, 84, 32, 66, 50, 92, 38, 72];                        // gap between a side card and the screen edge, per card
    var pts = [], L = 0;
    for (var i = 0; i <= 720; i++) {
      var t = i / 720 * Math.PI * 2, c = Math.cos(t), sn = Math.sin(t),
        x = CX + RX * Math.sign(c) * Math.pow(Math.abs(c), 2 / PW), y = CY + RY * Math.sign(sn) * Math.pow(Math.abs(sn), 2 / PW);
      if (i) L += Math.hypot(x - pts[i - 1].x, y - pts[i - 1].y);
      pts.push({ x: x, y: y, l: L });
    }
    function at(a) {
      a = ((a % L) + L) % L; var lo = 0, hi = pts.length - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (pts[m].l <= a) lo = m; else hi = m; }
      var A = pts[lo], B = pts[hi], f = (a - A.l) / ((B.l - A.l) || 1);
      return { x: A.x + (B.x - A.x) * f, y: A.y + (B.y - A.y) * f };
    }
    var GAP = L / N, AF = 0, best = 0;
    pts.forEach(function (p, j) { if (p.y > pts[best].y || (p.y == pts[best].y && Math.abs(p.x - CX) < Math.abs(pts[best].x - CX))) best = j; });
    AF = pts[best].l;                                                  // arc position of the centre spot
    function wrapD(d) { return ((d % L) + L * 1.5) % L - L / 2; }     // signed shortest distance along the loop
    var cards = els.map(function (d, j) {
      var im = $('img,svg', d); if (im) im.style.objectPosition = d.getAttribute('data-pos') || '50% 50%';
      d.style.setProperty('--dl', (j * 0.06).toFixed(2) + 's');
      return { d: d, w: +d.getAttribute('data-w') || 225, h: +d.getAttribute('data-h') || 265 };
    });
    var lx = 0, ly = 0, sc = 1, vy = 1, k = 1, FK = 1, Hd = 900, FY = FOCUS.y, HEADER = 55, TX0 = 0, TX1 = 0, TT = 0, TB = 0;
    function measure() {
      if (!hero.offsetWidth) return;                                   // phone view showing
      inner.style.setProperty('--s', hero.clientWidth / 1440 + 'px');  // full width on any screen
      var r = orbit.getBoundingClientRect(), bar = $('.lld .hd');
      sc = r.width / 1440 || 1; HEADER = (bar ? bar.offsetHeight : 55 * sc) / sc; vy = r.height / sc / 900 || 1; k = Math.min(1, vy);
      hero.style.setProperty('--hs', k.toFixed(3)); Hd = r.height / sc;
      // where the heading sits (design units): cards passing above/below it move out of its way
      var tb = $$('.hero-text h1,.hero-text p', hero).map(function (e) { var g = document.createRange(); g.selectNodeContents(e); return g.getBoundingClientRect(); });
      if (tb.length) {
        TX0 = (Math.min.apply(null, tb.map(function (b) { return b.left; })) - r.left) / sc; TX1 = (Math.max.apply(null, tb.map(function (b) { return b.right; })) - r.left) / sc;
        TT = (Math.min.apply(null, tb.map(function (b) { return b.top; })) - r.top) / sc; TB = (Math.max.apply(null, tb.map(function (b) { return b.bottom; })) - r.top) / sc;
      }
      // centre card sits on the bottom edge; on short/wide screens it shrinks (FK) so it never reaches the heading
      FK = clamp((Hd - TB - TGAP) / (FOCUS.h * k), .3, 1); FY = Hd - FOCUS.h * k * FK / 2;
    }
    function toDesign(e) { var r = orbit.getBoundingClientRect(); return [(e.clientX - r.left) / sc, (e.clientY - r.top) / sc / vy]; }
    orbit.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var deskMQ = matchMedia('(min-width:860px)');
    function onScroll() { if (deskMQ.matches) hero.style.setProperty('--sy', Math.min(scrollY, 1400)); }   // desktop only
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', measure); measure(); onScroll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    function mix(a, b, w) { return a + (b - a) * w; }
    function render(off) {
      var mid = (HEADER + Hd) / 2, rx = Math.min(RX, 1.3 * (Hd - HEADER) / 2);   // on wide/short screens the ring narrows too, so it stays round
      cards.forEach(function (c, j) {
        var a = off + j * GAP, P = at(a), g = Math.max(0, 1 - Math.abs(wrapD(a - AF)) / GAP), w = g * g * (3 - 2 * g);   // w: 1 at the centre spot
        var h = c.h * k, cw = c.w * k, py = mid + (P.y - CY) / RY * ((Hd - HEADER) / 2 + REACH * k),
          top = py < (TT + TB) / 2, side = Math.abs(P.x - CX) / RX > Math.abs(P.y - CY) / RY, px = CX + (P.x - CX) / RX * rx;
        if (side) h = Math.max(h, GAP * vy * 1.1); else cw = Math.max(cw, GAP * 1.1);     // neighbours always overlap
        var edge = SIDE[j % 8] / sc,
          near = clamp(1 - Math.max(0, TX0 - (px + cw / 2), px - cw / 2 - TX1) / 120, 0, 1);   // 1 when the card is level with the heading
        // above/below the heading: push the card outwards; trim its height only if more than CUT of it would hide
        var band = top ? TT - TGAP - HEADER : Hd - (TB + TGAP);
        h = mix(h, Math.min(h, Math.max(60, band) / (1 - CUT)), near);
        var ringY = mix(py, top ? Math.min(py, TT - TGAP - h / 2) : Math.max(py, TB + TGAP + h / 2), near);
        ringY = clamp(ringY, HEADER + h * (.5 - CUT), Hd - h * (.5 - CUT));            // never hide more than CUT of any card
        var ringX = clamp(px, edge + cw / 2, 1440 - edge - cw / 2);                      // side cards keep a gap from the screen edge
        var W = mix(cw, FOCUS.w * k * FK, w), H = mix(h, FOCUS.h * k * FK, w), X = mix(ringX, FOCUS.x, w), Y = mix(ringY, FY, w), st = c.d.style;
        st.width = 'calc(' + W.toFixed(1) + '*var(--s))'; st.height = 'calc(' + H.toFixed(1) + '*var(--s))';
        st.transform = 'translate3d(calc(' + (X - W / 2).toFixed(1) + '*var(--s)),calc(' + (Y - H / 2).toFixed(1) + '*var(--s)),0)';
        st.zIndex = w > 0 ? 20 + Math.round(w * 20) : j + 1;             // centre card above the others, under the heading
        st.setProperty('--label', Math.pow(w, 4).toFixed(3));
        st.setProperty('--k', (Math.max(.02, .4 * (1 - Y / vy / 900)) * (1 - w)).toFixed(3));   // the centre card doesn't drift on scroll
      });
    }
    var stop = heroRing({
      orbit: orbit, cards: els, card: '.orbit-card', L: L, GAP: GAP, AF: AF, spinK: .8, swipeK: .6, nameLink: true, centreOpens: true, render: render,
      autoMs: parseFloat(hero.getAttribute('data-auto-ms')) || 0, stepMs: parseFloat(hero.getAttribute('data-step-ms')) || 0,
      base: els.map(function (_, j) { return j * GAP; }), off: AF - (N - 1) * GAP,   // the last card starts in the centre, as on the phone
      shown: measure,                                                  // just switched to desktop: measure the real hero
      startDrag: function (e) { var p = toDesign(e); lx = p[0]; ly = p[1]; },
      // move along the loop by the part of the drag that follows its direction at the nearest point
      dragBy: function (e) {
        var p = toDesign(e), x = p[0], y = p[1], b = 0, bd = 1e12;
        for (var j = 0; j < pts.length; j += 2) { var d = Math.pow(pts[j].x - lx, 2) + Math.pow(pts[j].y - ly, 2); if (d < bd) { bd = d; b = j; } }
        var A = pts[b], B = pts[(b + 1) % pts.length], tx = B.x - A.x || 1e-6, ty = B.y - A.y, m = Math.hypot(tx, ty), dd = ((x - lx) * tx + (y - ly) * ty) / m;
        lx = x; ly = y; return dd;
      }
    });
    return function () { stop(); removeEventListener('scroll', onScroll); removeEventListener('resize', measure); };
  };

  /* feature: the cards sit side by side; hovering one opens it wide and folds the others into slim strips.
     Touch: the first tap opens a card, the second follows its link. CSS does the animating; this only toggles .open. */
  C['d-fcards'] = function (grid) {
    var cards = $$('.fcard', grid);
    if (!cards.length) return;
    // the caption gets 2 more copies, each fixed in its own place: big (open card) and small (slim strip); CSS cross-fades them
    cards.forEach(function (c) {
      var tx = $('.ftxt', c); if (!tx || $('.fbig', c)) return;
      ['fbig', 'fmini'].forEach(function (k) { var x = tx.cloneNode(true); x.classList.add(k); x.setAttribute('aria-hidden', 'true'); c.appendChild(x); });
    });
    function open(c) { cards.forEach(function (x) { x.classList.toggle('open', x === c); }); }
    cards.forEach(function (c) {
      c.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') open(c); });
      c.addEventListener('focus', function () { open(c); });
      c.addEventListener('click', function (e) { if (!c.classList.contains('open')) { e.preventDefault(); open(c); } });
    });
    grid.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') open(null); });
    grid.addEventListener('focusout', function (e) { if (!grid.contains(e.relatedTarget)) open(null); });
    // the theme editor: selecting a slide block opens its card
    function sel(e) { var i = cards.indexOf(e.target); if (i > -1) open(cards[i]); }
    document.addEventListener('shopify:block:select', sel);
    return function () { document.removeEventListener('shopify:block:select', sel); };
  };

  /* categories: the line nearest the middle of the screen turns black + underlined (or the one under the mouse);
     counts for big collections are filled in the same way as on the phone */
  C['d-cats'] = function (nav) {
    var links = $$('a', nav), raf = 0;
    function mark() {
      raf = 0; if (!nav.offsetWidth) return;
      var mid = innerHeight * .5, best = null, bd = 1e9;
      links.forEach(function (a) { var r = a.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid); if (d < bd) { bd = d; best = a; } });
      links.forEach(function (a) { a.classList.toggle('on', a === best && bd < innerHeight * .45); });
    }
    var deskMQ = matchMedia('(min-width:860px)');                     // desktop only: no work while the phone layout shows
    function onScroll() { if (deskMQ.matches && !raf) raf = requestAnimationFrame(mark); }
    addEventListener('scroll', onScroll, { passive: true }); mark();
    links.forEach(function (a) { a.addEventListener('mouseenter', function () { links.forEach(function (x) { x.classList.toggle('on', x === a); }); }); });
    C.categories(nav);
    return function () { removeEventListener('scroll', onScroll); };
  };

  /* rail: an endless strip that moves on its own and can be dragged with a short glide (logos, reviews, icons).
     The track's content is repeated until it is at least twice the strip's width, so the loop has no gap.
     It stops while the mouse is over the strip, or, when paused() is given, only while paused() says so. */
  function rail(strip, track, secs, extra, paused) {
    var x = 0, v = 0, half = 0, speed = 0, dn = false, px = 0, lt = 0, last = performance.now(), hold = 0, alive = true, raf,
      moved = 0, over = false, orig = [].slice.call(track.children);
    function fill() {
      $$('[data-clone]', track).forEach(function (c) { c.remove(); });
      if (!strip.offsetWidth || !orig.length) return;
      var one = track.scrollWidth, copies = Math.max(1, Math.ceil(strip.offsetWidth / Math.max(1, one)));
      for (var k = 0; k < copies * 2 - 1; k++) orig.forEach(function (el) {
        var c = el.cloneNode(true); c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        $$('a,button', c).concat(c.matches('a,button') ? [c] : []).forEach(function (f) { f.setAttribute('tabindex', '-1'); });
        track.appendChild(c);
      });
      half = track.scrollWidth / 2; speed = -half / secs;
    }
    function wrap() { if (half) { while (x <= -half) x += half; while (x > 0) x -= half; } }
    strip.addEventListener('pointerdown', function (e) { if (e.button) return; dn = true; moved = 0; px = e.clientX; lt = e.timeStamp; v = 0; });
    strip.addEventListener('pointermove', function (e) {
      if (!dn) return;
      var dx = e.clientX - px; moved += Math.abs(dx);
      if (moved < 6 && !strip.classList.contains('dragging')) return;
      if (!strip.classList.contains('dragging')) { strip.classList.add('dragging'); try { strip.setPointerCapture(e.pointerId); } catch (_) {} }
      v = dx / Math.max(1, e.timeStamp - lt) * 1000; x += dx; px = e.clientX; lt = e.timeStamp; wrap();
    });
    function up() { if (!dn) return; dn = false; strip.classList.remove('dragging'); hold = performance.now() + 900; }
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { strip.addEventListener(ev, up); });
    strip.addEventListener('click', function (e) { if (moved >= 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
    strip.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') over = true; });
    strip.addEventListener('pointerleave', function () { over = false; });
    var shown = false, vis = watch(strip);
    (function tick(now) {
      if (!alive) return;
      raf = requestAnimationFrame(tick);
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (!vis.w) { shown = false; return; }                           // phone view showing
      if (!vis.on) return;                                             // off screen: nothing to do
      if (!shown) { shown = true; fill(); }
      if (!dn) {
        if (Math.abs(v) > 5) { x += v * dt; v *= Math.pow(0.04, dt); }
        else { v = 0; if (!reduce && !(paused ? paused() : over) && now > hold) x += speed * dt; }
        wrap();
      }
      track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      if (extra) extra();
    })(last);
    function refill() { if (strip.offsetWidth) fill(); }
    addEventListener('resize', refill); addEventListener('load', refill);
    return function () { alive = false; cancelAnimationFrame(raf); removeEventListener('resize', refill); removeEventListener('load', refill); };
  }
  C['d-rail'] = function (strip) {
    var track = strip.firstElementChild; if (!track) return;
    return rail(strip, track, parseFloat(strip.getAttribute('data-seconds')) || 50);
  };
  /* icon strip: a rail whose named + red-filled icon is the one under the mouse, or the middle one when the mouse
     isn't over a product (Netlify 3 Nov). One icon is filled at a time. While the mouse is over a product the strip
     stops, so its name can be read; it carries on when the mouse leaves. */
  C['d-icons'] = function (strip) {
    var track = $('.itrack', strip), chip = $('.chip', strip), name = chip ? chip.textContent : '', mouse = null;
    if (!track) return;
    strip.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') mouse = { x: e.clientX, y: e.clientY }; });
    strip.addEventListener('pointerleave', function () { mouse = null; });
    function under() {                                                  // the product whose box the mouse is in (a little padding so thin icons are easy to hit)
      if (!mouse) return null;
      return [].find.call(track.children, function (it) {
        var r = it.getBoundingClientRect();
        return mouse.x >= r.left - 12 && mouse.x <= r.right + 12 && mouse.y >= r.top - 24 && mouse.y <= r.bottom + 12;
      }) || null;
    }
    // as in the design, the desktop view sits right after the Stores section (the phone view stays in place)
    var view = strip.closest('.lld[data-after]'), own = strip.closest('.shopify-section');
    if (view && own) {
      var after = $('.lld > .' + view.getAttribute('data-after')), host = after && after.closest('.shopify-section');
      if (host && host !== own) {
        $$('[data-moved-from="' + own.id + '"]').forEach(function (old) { if (old !== view) old.remove(); });   // left from an editor reload
        view.setAttribute('data-moved-from', own.id); view.classList.add('lld-moved');
        host.parentNode.insertBefore(view, host.nextSibling);
      }
    }
    var stop = rail(strip, track, parseFloat(strip.getAttribute('data-seconds')) || 45, function () {
      var rc = strip.getBoundingClientRect(); if (rc.top > innerHeight || rc.bottom < 0) return;
      var cx = innerWidth / 2, best = under(), bd = 1e9;
      if (!best) [].forEach.call(track.children, function (it) { var r = it.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - cx); if (d < bd) { bd = d; best = it; } });
      [].forEach.call(track.children, function (it) { it.classList.toggle('on', it === best); });
      var n = best && best.getAttribute('data-n');
      if (chip && n && n !== name) { name = n; chip.textContent = n; }
    }, function () { return !!under(); });
    ICO.wrap(track);                                                   // after rail(): it copies the icons, so the copies get a fill too
    return stop;
  };

  /* ---------- Smart Gifting row (phone + desktop): endless loop, moves on by itself, mouse drag glides to the nearest set.
       Only the shown gift sets count (hidden blocks aren't on the page). Desktop with 1-2 sets: no slider and no dots, the
       cards share the full width (CSS .gift-static). Phone with exactly 2 sets: a plain two-card swipe that goes back and
       forth (no copies, no endless loop). 3 or more: the endless loop with a sliver of the next set and the dots. ---------- */
  C['gift-row'] = function (row) {
    var sets = [].slice.call(row.children), n = sets.length, sec = row.closest('.gifting');
    if (n && n <= 2 && row.closest('.lld') && sec) {
      row.classList.add('gift-static'); sec.classList.add('gift-static'); sec.style.setProperty('--n', n);
      return function () { row.classList.remove('gift-static'); sec.classList.remove('gift-static'); sec.style.removeProperty('--n'); };
    }
    if (n < 2) return;
    var loopOn = n !== 2;
    // endless loop: two copies of the sets after the real ones; the row always sits in the middle copy.
    // The copies are what people see, so they must stay clickable (not inert); they're only hidden from
    // screen readers and the Tab order, which use the real sets.
    for (var k = 0; loopOn && k < 2; k++) sets.forEach(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block');
      $$('[data-shopify-editor-block]', c).forEach(function (x) { x.removeAttribute('data-shopify-editor-block'); });
      $$('a', c).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      row.appendChild(c);
    });
    var ms = parseFloat(row.getAttribute('data-ms')) || 0, anim = 0, idle = 0, iv = 0,
      down = false, moved = false, x0 = 0, left0 = 0, lastX = 0, lastT = 0, speed = 0, holdUntil = 0;
    function loopW() { return row.children[n].offsetLeft - row.children[0].offsetLeft; }        // one full set of cards
    function pitch() { return row.children[1].offsetLeft - row.children[0].offsetLeft; }        // one card + gap
    function recentre() { if (!loopOn) return; var L = loopW(); if (L) row.scrollLeft = L + ((row.scrollLeft % L) + L) % L; }   // same view, middle copy
    function stopNear(x) { var p = pitch(); return Math.round(x / p) * p; }   // scrollLeft k*pitch puts card k at the row's start (= its snap point)
    function maxLeft() { return row.scrollWidth - row.clientWidth; }
    // ease the scroll ourselves (0.6s ease-out) so it glides the same in every browser
    function glide(to) {
      if (!loopOn) to = clamp(to, 0, maxLeft());
      var from = row.scrollLeft, t0 = performance.now(), dur = reduce ? 0 : 600;
      row.classList.add('gliding'); cancelAnimationFrame(anim);
      (function step(now) {
        var p = dur ? Math.min(1, (now - t0) / dur) : 1;
        row.scrollLeft = from + (to - from) * (1 - Math.pow(1 - p, 3));
        if (p < 1) anim = requestAnimationFrame(step); else { recentre(); row.classList.remove('gliding'); }   // back to the middle copy before snapping is back on
      })(t0);
    }
    // mouse drag (touch scrolls natively)
    row.addEventListener('pointerdown', function (e) {
      holdUntil = performance.now() + 6000;
      if (e.pointerType !== 'mouse' || e.button) return;
      cancelAnimationFrame(anim); row.classList.remove('gliding');
      down = true; moved = false; x0 = lastX = e.clientX; left0 = row.scrollLeft; lastT = e.timeStamp; speed = 0;
    });
    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved) { if (Math.abs(dx) < 6) return; moved = true; row.classList.add('dragging'); try { row.setPointerCapture(e.pointerId); } catch (_) {} }
      row.scrollLeft = left0 - dx;
      speed = (e.clientX - lastX) / Math.max(1, e.timeStamp - lastT); lastX = e.clientX; lastT = e.timeStamp;
    });
    function up() {
      if (!down) return; down = false; if (!moved) return;
      row.classList.remove('dragging');
      glide(stopNear(row.scrollLeft - speed * 250));                       // a quick flick goes a bit further
    }
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { row.addEventListener(ev, up); });
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });                                   // links/images must not start a native drag
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);   // a drag is not a click
    // after a swipe settles, jump (invisibly) back to the middle copy
    row.addEventListener('scroll', function () {
      clearTimeout(idle); idle = setTimeout(function () { if (!down && !row.classList.contains('gliding')) recentre(); }, 150);
    }, { passive: true });
    // move on every few seconds; pauses while hovered, touched or focused.
    // Only a real mouse hover or keyboard focus pauses it (a tap on a phone also fires mouse/focus events, which must not stop it for good)
    row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') holdUntil = Infinity; });
    row.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') holdUntil = performance.now() + 1500; });
    row.addEventListener('focusin', function (e) { if (e.target.matches(':focus-visible')) holdUntil = Infinity; });
    row.addEventListener('focusout', function () { if (holdUntil === Infinity && !row.matches(':hover')) holdUntil = performance.now() + 1500; });
    row.addEventListener('touchstart', function () { holdUntil = performance.now() + 6000; }, { passive: true });
    if (ms > 0 && !reduce && !design) iv = setInterval(function () {
      if (down || document.hidden || performance.now() < holdUntil || !row.offsetWidth) return;
      if (loopOn || row.scrollLeft < maxLeft() - 2) glide(stopNear(row.scrollLeft) + pitch()); else glide(0);   // 2 sets: back and forth
    }, ms);
    // pagination dots under the row: one per set, the current one long + red; a click glides to that set the short way round
    var dots = document.createElement('div');
    dots.className = 'gift-dots';
    function current() {
      var p = pitch(); if (!p) return 0;
      if (!loopOn) return row.scrollLeft >= maxLeft() - 2 ? n - 1 : clamp(Math.round(row.scrollLeft / p), 0, n - 1);   // the last set may not reach the row's start
      return ((Math.round(row.scrollLeft / p) % n) + n) % n;
    }
    sets.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Show gift set ' + (i + 1));
      b.addEventListener('click', function () { holdUntil = performance.now() + 6000; var d = (i - current() + n) % n; if (d > n / 2) d -= n; glide(loopOn ? stopNear(row.scrollLeft) + d * pitch() : i * pitch()); });
      dots.appendChild(b);
    });
    row.parentNode.insertBefore(dots, row.nextSibling);
    function paint() { var c = current(); [].forEach.call(dots.children, function (b, i) { b.classList.toggle('on', i === c); }); }
    row.addEventListener('scroll', paint, { passive: true });
    // theme editor: selecting a gift set scrolls it into view
    function sel(e) { var j = sets.indexOf(e.target); if (j > -1 && row.offsetWidth) glide(row.children[loopOn ? n + j : j].offsetLeft - row.children[0].offsetLeft); }
    document.addEventListener('shopify:block:select', sel);
    requestAnimationFrame(function () { recentre(); paint(); });
    addEventListener('resize', recentre); addEventListener('load', recentre);
    return function () {
      clearInterval(iv); cancelAnimationFrame(anim); clearTimeout(idle); dots.remove();
      removeEventListener('resize', recentre); removeEventListener('load', recentre);
      document.removeEventListener('shopify:block:select', sel);
    };
  };

  /* FAQ: after collapsing "show more", keep the button in view */
  C['d-faq'] = function (sec) {
    var t = $('.faq-toggle input', sec); if (!t) return;
    t.addEventListener('change', function () {
      if (t.checked) return;
      setTimeout(function () { var b = t.parentNode, r = b.getBoundingClientRect(); if (r.top < 0 || r.bottom > innerHeight) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 460);
    });
  };

  /* page width without the scrollbar, for the desktop sizes (--cw in lifelong-desktop.css) */
  function setCw() { document.documentElement.style.setProperty('--cw', document.documentElement.clientWidth + 'px'); }
  setCw();
  // window resizes, plus the scrollbar appearing or going (which changes the width without a resize event)
  addEventListener('resize', setCw); addEventListener('load', setCw);
  if (window.ResizeObserver) new ResizeObserver(setCw).observe(document.body);

  /* in-page links (#faq) point at the phone view; on desktop go to the desktop view's copy (#faq-d) */
  document.addEventListener('click', function (e) {
    var j = e.target.closest('a[href*="#"]');
    if (j && j.pathname === location.pathname) LL.jumpUntil = performance.now() + 2500;   // a jump within this page: the red section lets it through
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1), el = id && document.getElementById(id);
    if (el && !el.offsetWidth) { var alt = document.getElementById(id + '-d'); if (alt && alt.offsetWidth) { e.preventDefault(); scrollToEl(alt); } }
  });
  // smooth scroll to an element; photos that load on the way can push it further down, so check again and finish the trip
  function scrollToEl(el, tries) {
    tries = tries || 0; LL.jumpUntil = performance.now() + 2500;
    el.scrollIntoView({ behavior: tries ? 'auto' : 'smooth' });
    if (tries < 3) setTimeout(function () {
      var top = el.getBoundingClientRect().top, want = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      if (Math.abs(top - want) > 30) scrollToEl(el, tries + 1);
    }, tries ? 400 : 1000);
  }

  /* ---------- boot ---------- */
  function init(scope) {
    $$('[data-ll]', scope).forEach(function (el) {
      if ('_llOff' in el) return;
      var f = C[el.getAttribute('data-ll')];
      if (!f) return;                       // may belong to lifelong-pdp.js, which registers itself later
      el._llOff = f(el) || null;
    });
  }
  function destroy(scope) { $$('[data-ll]', scope).forEach(function (el) { if (el._llOff) el._llOff(); delete el._llOff; }); }
  // shared with lifelong-pdp.js (product page): it adds its components to LL.C and calls LL.init
  LL.C = C; LL.init = init; LL.toast = toast; LL.money = money; LL.json = json; LL.esc = esc;
  LL.rail = rail; LL.ICO = ICO;                                       // the product page's Discover strip reuses the home page's icon strip
  init(document);
  // a link like /#faq from another page: the desktop view has its own copy of the section (id + "-d")
  if (location.hash.length > 1) {
    LL.jumpUntil = performance.now() + 3000;                          // the browser jumps to it on load: let it through
    var hashD = document.getElementById(location.hash.slice(1) + '-d');
    if (hashD && hashD.offsetWidth) setTimeout(function () { scrollToEl(hashD, 1); }, 300);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
